import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=455503b0&lang=pug"
import script from "./Create.vue?vue&type=script&lang=ts"
export * from "./Create.vue?vue&type=script&lang=ts"
import style0 from "./Create.vue?vue&type=style&index=0&id=455503b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports